// Sanaa AI parent brand mark — official PNG logo
export default function SanaaMark({ size = 28, className = "" }) {
  return (
    <div
      className={`shrink-0 flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img
        src="/logos/sanaa.png"
        alt="Sanaa AI"
        className="w-full h-full object-contain"
        style={{ filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.18))" }}
      />
    </div>
  );
}
